export default "__VITE_ASSET__C9Uxroer__"